/* ==========================================================================
   Ecofynd Guide — reusable behavior (scroll reveal, page counter, progress)
   One file, shared by every guide page. Do not fork per guide.
   ========================================================================== */

(function () {
  document.querySelectorAll('[data-eco-guide]').forEach(initGuide);

  function initGuide(root) {
    var pages = Array.prototype.slice.call(root.querySelectorAll('[data-eco-page]'));
    if (!pages.length) return;

    var currentPageEl = root.querySelector('[data-eco-current-page]');
    var navFill = root.querySelector('[data-eco-nav-fill]');
    var scrollHint = root.querySelector('[data-eco-scroll-hint]');
    var startBtn = root.querySelector('[data-eco-start]');

    // Reveal-on-scroll
    if ('IntersectionObserver' in window) {
      var revealObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              entry.target.classList.add('is-visible');
              revealObserver.unobserve(entry.target);
            }
          });
        },
        { threshold: 0.15, rootMargin: '0px 0px -10% 0px' }
      );
      pages.forEach(function (page) {
        revealObserver.observe(page);
      });
    } else {
      pages.forEach(function (page) {
        page.classList.add('is-visible');
      });
    }

    // Page counter + progress bar
    if (currentPageEl || navFill) {
      var counterObserver = new IntersectionObserver(
        function (entries) {
          entries.forEach(function (entry) {
            if (entry.isIntersecting) {
              var pageNumber = parseInt(entry.target.getAttribute('data-page-number'), 10) || 1;
              if (currentPageEl) currentPageEl.textContent = pageNumber;
              if (navFill) {
                var percent = (pageNumber / pages.length) * 100;
                navFill.style.width = percent + '%';
              }
            }
          });
        },
        { threshold: 0.5 }
      );
      pages.forEach(function (page) {
        counterObserver.observe(page);
      });
    }

    // Hide scroll hint once the reader starts scrolling
    if (scrollHint) {
      var hideHint = function () {
        scrollHint.classList.add('is-hidden');
        window.removeEventListener('scroll', hideHint);
      };
      window.addEventListener('scroll', hideHint, { passive: true, once: true });
    }

    // Smooth scroll for "Start reading"
    if (startBtn) {
      startBtn.addEventListener('click', function (e) {
        var target = document.querySelector(startBtn.getAttribute('href'));
        if (target) {
          e.preventDefault();
          target.scrollIntoView({ behavior: 'smooth', block: 'start' });
        }
      });
    }
  }
})();